import React from 'react'
import NavBar from '../shared/NavBar/NavBar'
import { BackButton, baseUrl } from './Examples'

const ExampleNavbar = (): JSX.Element => {
    return (
        <div style={{ top: 100, position: 'relative' }}>
            <BackButton href={baseUrl} />

            <div>
                <NavBar
                    title={'Example'}
                    route={'/#/dashboards'}
                    historic={{
                        createdAt: 1629388800000,
                        updatedAt: 1629388800000
                    }}
                    historicFormat={'dd/MM/yyyy'}
                />
            </div>
        </div>
    )
}

export default ExampleNavbar
